module.exports = __webpack_public_path__ + "img/no-res-logo.4b41433d.svg";